"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsServiceClient = void 0;
const client_library_1 = require("@seneca/client-library");
const ErrorMapping_1 = require("./ErrorMapping");
const errors_1 = require("./errors");
class TagsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    /**
     * Creates a  new tag
     * @throws {TagExistsError} if the tag already exists
     * @throws {TagParentDoesNotExistError} if a category with a matching parent ID does not exist
     *
     */
    async createTag(tag) {
        const response = await this.requestMaker.makeRequest(`${this.url}/api/tags`, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ type: 'tag' }, tag))
        }, [201, 400, 404]);
        if (response.status === 404) {
            throw new errors_1.TagParentDoesNotExistError();
        }
        if (response.status === 400) {
            (0, ErrorMapping_1.throwErrorFromResponse)(response);
        }
        return response.json;
    }
    /**
     * Creates a new tag category
     */
    async createCategory(tag) {
        const response = await this.requestMaker.makeRequest(`${this.url}/api/tags`, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ type: 'category' }, tag))
        }, [201]);
        return response.json;
    }
    /**
     * Delete a tag or category
     *
     * @throws {NotFoundError} when try to delete tag that does not exist
     * @throws {TagHasChildrenError} when try to delete a tag that has child tags
     */
    async deleteTag(tagId, type) {
        const response = await this.requestMaker.makeRequest(`${this.url}/api/tags/${tagId}`, {
            method: 'DELETE',
            body: JSON.stringify({ type })
        }, [204, 400, 404]);
        if (response.status === 404) {
            throw new errors_1.NotFoundError(tagId);
        }
        if (response.status === 400) {
            (0, ErrorMapping_1.throwErrorFromResponse)(response);
        }
    }
    /**
     * Update a tag or category
     *
     * @throws {NotFoundError} when try to update tag that does not exist
     * @throws {TagExistsError} when tag with same text already exists within parent category
     * @throws {NumberOfTagChildrenCannotBeAlteredError} when try to add or delete child tags through this method
     */
    async updateTag(tagId, tag) {
        const response = await this.requestMaker.makeRequest(`${this.url}/api/tags/${tagId}`, {
            method: 'PATCH',
            body: JSON.stringify(tag)
        }, [200, 400, 404]);
        if (response.status === 404) {
            throw new errors_1.NotFoundError(tagId);
        }
        if (response.status === 400) {
            (0, ErrorMapping_1.throwErrorFromResponse)(response);
        }
        return response.json;
    }
    /**
     * Fetch all tags and categories in a flat structure
     */
    async fetchAll(options = {}) {
        let items = [];
        let lastKey = undefined;
        do {
            const page = await this.fetchPageOfTags({
                limit: options.limit,
                lastKey,
                region: options.region,
                includeNonCourseFilters: options.includeNonCourseFilters
            });
            lastKey = page.lastKey;
            items = items.concat(page.tags);
        } while (lastKey);
        return {
            tags: items,
            count: items.length
        };
    }
    /**
     * Fetch all tags and categories for specific semanticCategory
     */
    async fetchTagsBySemanticCategory(semanticCategory, options) {
        const allTags = await this.fetchAll(options);
        const matchingTags = allTags.tags.filter(tag => tag.semanticCategory === semanticCategory);
        return {
            tags: matchingTags,
            count: matchingTags.length
        };
    }
    /**
     * Fetch a single page of tags
     */
    async fetchPageOfTags(options) {
        const response = await this.requestMaker.makeRequest(`${this.url}/api/tags?${this.encodeQueryParams({
            limit: options.limit,
            lastKey: options.lastKey,
            includeNonCourseFilters: options.includeNonCourseFilters
        })}`, {
            method: 'GET',
            region: options.region
        }, [200, 400]);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    encodeQueryParams(params) {
        return Object.entries(params)
            .flatMap(([key, value]) => value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : [])
            .join('&');
    }
}
exports.TagsServiceClient = TagsServiceClient;
//# sourceMappingURL=TagsServiceClient.js.map